<template>
  <div
      class="flex-column align-items-center justify-content-between"
  >
    <label class="mx-2 my-1 text-nowrap" :for="field.id + '-field'">
      {{field.fa_name || field.name }}
    </label>
    <div class="d-flex justify-content-center align-items-center">
      <select
          class="form-control kt-selectpicker mx-2"
          v-model="default_status"
          :id="field.id + '-field'"
          :disabled="is_disable"
      >
        <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
        >
          {{option.fa_name}}
        </option>
      </select>
      <button
          type="button"
          class="btn btn-danger"
          @click="removeOption(field.id)"
          v-if="!is_disable"
      >
        حذف
      </button>
    </div>
  </div>
</template>

<script>
import {fieldOptions} from "@/constants/CustomerFormatFieldOptions";

export default {
  name: "CustomerFormatField",
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  computed : {
    is_disable() {
      if(this.field.details) {
        return this.field.details.some(i => i.type === 'disable' && i.data === 'true')
      }

      return false
    },
    options() {
      return fieldOptions
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: true,
        rtl: false
      }

      return toastr
    },
    default_status: {
      get() {
        // exactly what you already have in your getter:
        if (this.field.status !== undefined) {
          return this.field.status;
        }
        if (!this.field.details) {
          return null;
        }
        const defaultDetail = this.field.details.find(item => item.type === 'default_status');
        if (defaultDetail) {
            const match = this.options.find(option => option.name === defaultDetail.data);
            this.field.status = match ? match.value : null
            return match ? match.value : null;
        }
        return null;
      },
      set(newValue) {
        this.$emit('field-status-changed', {
          ...this.field,
          status: newValue
        });
      }
    }
  },
  methods: {
    removeOption(field_id) {
      this.$emit('remove-field', field_id)
    },
  },
}
</script>

<style scoped>

</style>